import Airplane from "../surveyIcons/Airplane"
import AlarmClock from "../surveyIcons/AlarmClock"
import Balance from "../surveyIcons/Balance"
import Books from "../surveyIcons/Books"
import Brain from "../surveyIcons/Brain"
import Brainstorm from "../surveyIcons/Brainstorm"
import Briefcase from "../surveyIcons/Briefcase"
import Cake from "../surveyIcons/Cake"
import Car from "../surveyIcons/Car"
import ChainLink from "../surveyIcons/ChainLink"
import ChatBubble from "../surveyIcons/ChatBubble"
import Checked from "../surveyIcons/Checked"
import Clipboard from "../surveyIcons/Clipboard"
import Cog from "../surveyIcons/Cog"
import Cross from "../surveyIcons/Cross"
import Desk from "../surveyIcons/Desk"
import Envelope from "../surveyIcons/Envelope"
import Environment from "../surveyIcons/Environment"
import Factory from "../surveyIcons/Factory"
import Family from "../surveyIcons/Family"
import FirstAidKit from "../surveyIcons/FirstAidKit"
import Friendship from "../surveyIcons/Friendship"
import Handshake from "../surveyIcons/Handshake"
import Heart from "../surveyIcons/Heart"
import House from "../surveyIcons/House"
import Information from "../surveyIcons/Information"
import Laptop from "../surveyIcons/Laptop"
import Leaf from "../surveyIcons/Leaf"
import Lightbulb from "../surveyIcons/Lightbulb"
import LineChart from "../surveyIcons/LineChart"
import Map from "../surveyIcons/Map"
import Medal from "../surveyIcons/Medal"
import Megaphone from "../surveyIcons/Megaphone"
import MoneyStack from "../surveyIcons/MoneyStack"
import PaperAirplane from "../surveyIcons/PaperAirplane"
import PaperStack from "../surveyIcons/PaperStack"
import Person from "../surveyIcons/Person"
import Plant from "../surveyIcons/Plant"
import Plus from "../surveyIcons/Plus"
import Podium from "../surveyIcons/Podium"
import Present from "../surveyIcons/Present"
import Question from "../surveyIcons/Question"
import Recycle from "../surveyIcons/Recycle"
import Relationship from "../surveyIcons/Relationship"
import Resources from "../surveyIcons/Resources"
import Running from "../surveyIcons/Running"
import SafetyHelmet from "../surveyIcons/SafetyHelmet"
import Shop from "../surveyIcons/Shop"
import Smile from "../surveyIcons/Smile"
import Star from "../surveyIcons/Star"
import Sun from "../surveyIcons/Sun"
import Target from "../surveyIcons/Target"
import ThoughtBubble from "../surveyIcons/ThoughtBubble"
import ThumbsUp from "../surveyIcons/ThumbsUp"
import Tick from "../surveyIcons/Tick"
import Toolbox from "../surveyIcons/Toolbox"
import Tree from "../surveyIcons/Tree"
import Trophy from "../surveyIcons/Trophy"
import Umbrella from "../surveyIcons/Umbrella"
import UsersChat from "../surveyIcons/UsersChat"
import Wheel from "../surveyIcons/Wheel"
import ZoomIn from "../surveyIcons/ZoomIn"

export const surveyIconMapping = {
  airplane: Airplane,
  alarmClock: AlarmClock,
  balance: Balance,
  books: Books,
  brain: Brain,
  brainstorm: Brainstorm,
  briefcase: Briefcase,
  cake: Cake,
  car: Car,
  chainLink: ChainLink,
  chatBubble: ChatBubble,
  checked: Checked,
  clipboard: Clipboard,
  cog: Cog,
  cross: Cross,
  desk: Desk,
  envelope: Envelope,
  environment: Environment,
  factory: Factory,
  family: Family,
  firstAidKit: FirstAidKit,
  friendship: Friendship,
  handshake: Handshake,
  heart: Heart,
  house: House,
  information: Information,
  laptop: Laptop,
  leaf: Leaf,
  lightbulb: Lightbulb,
  lineChart: LineChart,
  map: Map,
  medal: Medal,
  megaphone: Megaphone,
  moneyStack: MoneyStack,
  paperAirplane: PaperAirplane,
  paperStack: PaperStack,
  person: Person,
  plant: Plant,
  plus: Plus,
  podium: Podium,
  present: Present,
  question: Question,
  recycle: Recycle,
  relationship: Relationship,
  resources: Resources,
  running: Running,
  safetyHelmet: SafetyHelmet,
  shop: Shop,
  smile: Smile,
  star: Star,
  sun: Sun,
  target: Target,
  thoughtBubble: ThoughtBubble,
  thumbsUp: ThumbsUp,
  tick: Tick,
  toolbox: Toolbox,
  tree: Tree,
  trophy: Trophy,
  umbrella: Umbrella,
  usersChat: UsersChat,
  wheel: Wheel,
  zoomIn: ZoomIn
}

export default surveyIconMapping
